module.exports = __webpack_public_path__ + "static/CareLabel-v4-674c63cf71a0c6a689a0da3ab68c2f9f.svg";